﻿import { setupScrolling } from '@eurotunnel-pax/leshuttle.ui/src/scripts/components/controls/drag-scroll'

export class ArticleListing {
  constructor (elem) {
    this.elem = elem
    this.href = window.location.href

    if (this.elem.dataset.listCurrent) {
      this.href = this.elem.dataset.listCurrent
    }

    this.fetchUrl = this.href

    this.type = ''
    this.offer = ''
    this.country = ''
    this.inspiration = ''

    this.categoryDependencies = {
      type: ['country', 'inspiration'],
      country: ['inspiration']
    }

    this.setupRadioListeners('type')
    this.setupRadioListeners('offer')
    this.setupRadioListeners('country')
    this.setupRadioListeners('inspiration')

    this.setupLinks()
    this.setupForm()
  }

  setupForm () {
    const pageForm = this.elem.querySelector('[data-paging-form]')

    if (pageForm) {
      pageForm.addEventListener('submit', (e) => {
        e.preventDefault()
        pageForm.validator.validateForm().then((formData) => {
          const kvpairs = []
          for (const entry of formData.entries()) {
            if (entry[1] != null && entry[1].toString().length > 0) {
              kvpairs.push(encodeURIComponent(entry[0]).toLowerCase() + '=' + encodeURIComponent(entry[1]).toLowerCase())
            }
          }
          const queryString = kvpairs.join('&')
          if (queryString.length > 0) {
            this.href = pageForm.action + '?' + queryString
          } else {
            this.href = pageForm.action
          }

          this.fetchUrl = this.href

          this.navigate()
        }).catch(errors => {
          console.log(errors)
        })
      })
    }
  }

  setupLinks () {
    const pageLinks = this.elem.querySelectorAll('[data-paging] a')

    if (pageLinks) {
      for (const pageLink of pageLinks) {
        pageLink.addEventListener('click', (e) => {
          e.preventDefault()
          const href = new URL(pageLink.href)
          const fetchHref = href

          if (this.type !== undefined && this.type !== '' && this.type !== null) {
            href.searchParams.set('type', this.type)
          }

          if (this.offer !== undefined && this.offer !== '' && this.offer !== null) {
            href.searchParams.set('offer', this.offer)
          }

          if (this.country !== undefined && this.country !== '' && this.country !== null) {
            href.searchParams.set('country', this.country)
          }

          if (this.inspiration !== undefined && this.inspiration !== '' && this.inspiration !== null) {
            href.searchParams.set('inspiration', this.inspiration)
          }

          this.href = href.toString()
          this.fetchUrl = fetchHref.toString()
          this.navigate()
        })
      }
    }
  }

  setupRadioListeners (category) {
    const radios = this.elem.querySelectorAll(`[data-cat-radio="${category}"]`)
    if (radios.length > 0) {
      const paramName = category.toLowerCase()

      for (const radio of radios) {
        radio.addEventListener('click', (e) => {
          this[paramName] = e.target.value
          this.updateUrlParameter(paramName, this[paramName])

          if (this.categoryDependencies[category]) {
            this.categoryDependencies[category].forEach(dependentCategory => {
              this[dependentCategory] = ''
              this.updateUrlParameter(dependentCategory, '') // Reset dependent category
            })
          }

          this.navigate()
          e.target.focus()
        })
      }

      // Initialize the parameter value from the URL
      const href = new URL(this.href)
      this[paramName] = href.searchParams.get(paramName)
    }
  }

  updateUrlParameter (param, value) {
    const href = new URL(this.href)
    if (href.searchParams.has('page')) {
      href.searchParams.delete('page')
    }
    if (href.searchParams.has(param)) {
      href.searchParams.delete(param)
    }
    if (value !== '') {
      href.searchParams.set(param, value)
    }

    this.href = href.toString()
    this.fetchUrl = this.href
  }

  navigate () {
    const options = {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    }

    fetch(this.fetchUrl, options).then((response) => {
      return response.text()
    }).then((data) => {
      this.updateHistory(data, this.href)
      this.updateContents(data)
      this.setupLinks()
      this.setupRadioListeners('type')
      this.setupRadioListeners('offer')
      this.setupRadioListeners('country')
      this.setupRadioListeners('inspiration')
      this.setupForm()
      window.scrollTo({
        top: this.elem.querySelector('[data-filter-form]').offsetTop - 150,
        behavior: 'smooth'
      })

      const event = new CustomEvent('form-updated', { bubbles: true })
      this.elem.dispatchEvent(event)
      setupScrolling(this.elem)
    })
  }

  updateHistory (data, url) {
    if (window.history) {
      history.replaceState(data, document.title, url)
    }
  }

  updateContents (data) {
    this.elem.style.height = `${this.elem.offsetHeight}px`

    this.elem.innerHTML = data

    window.setTimeout(() => this.elem.style.removeProperty('height'), 1)
  }
}

export const setupArticleListing = function () {
  const lists = document.querySelectorAll('[data-article-list-paging]')
  const pagingLists = []
  for (let i = 0; i < lists.length; i++) {
    pagingLists.push(new ArticleListing(lists[i]))
  }
}
